import '@descope-ui/descope-list';
import '@descope-ui/descope-list-item';
import '@descope-ui/descope-text';
import '@descope-ui/descope-avatar';
import '@descope-ui/descope-button';
import { componentName, OutboundAppsClass } from './OutboundAppsClass';

customElements.define(componentName, OutboundAppsClass);

export { OutboundAppsClass, componentName };
